
export const API_HOST = 'https://portfolioapis-1-q1238407.deta.app';